import React from "react";
import { useTranslation } from "react-i18next";
import styled, { withTheme } from "styled-components";

const NutritionItemWrapper = styled.div`
  color: ${(props) => props.titleColor || props.theme?.darkPurple};
  font-weight: 600;
  padding: 8px 10px;
  font-size: 16px;
  background: ${(props) =>
    props.backgroundColor || props.theme?.lightShadeMagenta};
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  & .value {
    color: ${(props) =>
      props.titleColor === props.theme?.white
        ? props.theme?.white
        : props.theme?.nero};
    font-size: 16px;
  }
`;

const FastingDayWrapper = styled.span`
  color: ${(props) => props?.theme?.chiliRed};
`;

const NutritionItem = (props) => {
  const {
    isFastingDay,
    isModal,
    value,
    title,
    backgroundColor,
    titleColor,
    className,
  } = props;

  const { t } = useTranslation();

  return (
    <NutritionItemWrapper
      className={className}
      data-testid="nutrition-item-wrapper"
      {...{ backgroundColor }}
      {...{ titleColor }}
    >
      <span>{title || `${t("appText.dietDiary.calories")}:`}</span>
      <span className="value">
        {isFastingDay && isModal ? (
          <FastingDayWrapper>{value}</FastingDayWrapper>
        ) : (
          <span>{value || "0.00 kcal"}</span>
        )}
      </span>
    </NutritionItemWrapper>
  );
};
export default withTheme(NutritionItem);
